import type { Translation } from '../types.ts';
import type en from '../en/checkout.ts';

export default {
    shared: {
        defaultLocale: '(std)',
    },
    returnFees: {
        free: 'Gratis retourneren',
        customer: 'Klant betaalt de verzendkosten',
        fixed: 'Vaste retourkosten',
    },
    settings: {
        saved: 'Afrekeninstellingen opgeslagen',
        save: 'Afrekeninstellingen opslaan',
    },
    shipping: {
        title: 'Verzending',
        introModule: 'Wordt berekend als geen tarief in de tarieventabel bij het adres past. Zet hieronder "Alleen bestellingen aannemen die we kunnen bezorgen" aan om zulke bestellingen te weigeren.',
        introFlat: 'Vast verzendtarief voor elke bestelling. Laat de drempel voor gratis verzending leeg om altijd het vaste tarief te rekenen; vul een bedrag in om de verzendkosten te laten vervallen zodra het brutototaal van een bestelling (incl. btw) dat bereikt.',
        cents: 'Alle bedragen in centen (bijv. {example} = € 4,95).',
        noRateMatch: 'Prijs als geen tarief past (centen)',
        flatRate: 'Vast verzendtarief (centen)',
        freeThreshold: 'Drempel gratis verzending (centen)',
        freeThresholdPlaceholder: 'Leeg laten om uit te schakelen',
        requireSelection: 'Alleen bestellingen aannemen die we kunnen bezorgen',
        requireSelectionHint: 'Weiger het afrekenen als de tarieventabel geen optie voor het adres heeft, voor een bedrijf dat zelf bezorgt binnen de eigen postcodes. Staat dit uit, dan kost zo\'n bestelling de prijs hierboven. Vereist minstens één zone.',
    },
    google: {
        title: 'Google Shopping-vermeldingen',
        intro: 'Staat in de gestructureerde gegevens van elk product, zodat Google producten in de gratis Shopping-vermeldingen kan tonen met levertijd en retourvoorwaarden. Leeg betekent "niet vermeld": Google krijgt dan niets te horen in plaats van een gok. Dagen zijn werkdagen.',
        defaultBrand: 'Standaardmerk',
        defaultBrandHint: 'Voor producten zonder eigen merk',
        handlingMin: 'Verwerkingstijd, min. dagen',
        handlingMinHint: 'Van bestelling tot overdracht van het pakket; 0 = dezelfde dag',
        handlingMax: 'Verwerkingstijd, max. dagen',
        transitMin: 'Vervoerstijd, min. dagen',
        transitMinHintModule: 'Voor tarieven zonder eigen levertijd',
        transitMinHint: 'Tijd van de vervoerder tot de klant',
        transitMax: 'Vervoerstijd, max. dagen',
        returnDays: 'Retourtermijn (dagen)',
        returnDaysHint: '0 = geen retouren',
        returnCosts: 'Retourkosten',
        returnFee: 'Retourkosten (centen)',
    },
    notifications: {
        title: 'Bestelmeldingen',
        email: 'E-mail voor bestelmeldingen',
        emailPlaceholder: "verkoop{'@'}voorbeeld.nl, magazijn{'@'}voorbeeld.nl",
        help: 'Optioneel. Een of meer adressen (gescheiden door komma\'s) die een e-mail "nieuwe bestelling" krijgen zodra een klant betaalt. Laat leeg om uit te schakelen.',
    },
    countries: {
        title: 'Geaccepteerde landen',
        intro: 'De landen die een klant kan kiezen bij het afrekenen en in de adresformulieren van de webwinkel. {warning}: afrekenen is geblokkeerd tot je er minstens één toevoegt.',
        introWarning: 'Laat je dit leeg, dan is geen enkel land te kiezen',
        remove: '{country} verwijderen',
        none: 'Geen landen ingeschakeld: afrekenen in de webwinkel is nu geblokkeerd.',
        add: 'Land toevoegen…',
    },
    sender: {
        title: 'Afzender bestelmails',
        intro: 'Optioneel, voor orderbevestigingen en meldingen aan beheerders. Laat leeg om de standaardafzender van de website te gebruiken.',
        fromEmail: 'Afzenderadres',
        fromName: 'Afzendernaam',
        noDefaultEmail: 'Stel eerst de standaard van de website in',
        defaultName: 'Valt terug op de standaard van de website',
    },
    payments: {
        title: 'Betaalmethoden',
        intro: 'Schakel de betaalmethoden in die deze website bij het afrekenen aanbiedt. Een methode kan pas aan als alle inloggegevens ervan zijn ingevuld.',
        requires: 'vereist {fields}',
        noCredentials: 'geen inloggegevens nodig',
        credentialSaved: '•••••••• (opgeslagen, leeg laten om te behouden)',
        displayName: 'Weergavenaam',
        blankUses: '(leeg gebruikt “{label}”)',
    },
} satisfies Translation<typeof en>;
